if (!customElements.get('cart-complete-setup')) {
  class CartCompleteSetup extends HTMLElement {
    constructor() {
      super();
      this.onClick = this.onClick.bind(this);
    }

    connectedCallback() {
      this.initCarousel();
      this.addEventListener('click', this.onClick);
      this.hydrateRatings();
      this.prefetchQuickViews();
    }

    prefetchQuickViews() {
      customElements.whenDefined('cart-quick-view').then(() => {
        if (!this.isConnected) return;
        const quickView = document.querySelector('cart-quick-view');
        if (!quickView) return;
        this.querySelectorAll('.complete-setup__add[data-quick-view]').forEach((button) => {
          quickView.prefetch(button.dataset.productUrl);
        });
      });
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      if (this.visibilityObserver) {
        this.visibilityObserver.disconnect();
        this.visibilityObserver = null;
      }
      if (this.swiper) {
        this.swiper.destroy();
        this.swiper = null;
      }
    }

    initCarousel() {
      if (typeof Swiper === 'undefined') return;
      const nav = this.closest('.complete-setup')?.querySelector('.complete-setup__nav');
      this.swiper = new Swiper(this, {
        navigation: {
          prevEl: nav?.querySelector('.swiper-button-prev'),
          nextEl: nav?.querySelector('.swiper-button-next')
        },
        slidesPerView: 'auto',
        spaceBetween: 8,
        allowTouchMove: true,
        observer: true,
        breakpoints: {
          750: {
            spaceBetween: 10
          }
        },
        pagination: {
          el: this.querySelector('.swiper-pagination'),
          type: 'bullets',
          clickable: true
        }
      });
      this.swiper.navigation?.update();
      const drawer = this.closest('cart-drawer');
      if (drawer) {
        this.visibilityObserver = new MutationObserver(() => {
          if (!drawer.classList.contains('active')) return;
          requestAnimationFrame(() => {
            this.swiper?.update();
            this.swiper?.navigation?.update();
          });
        });
        this.visibilityObserver.observe(drawer, { attributes: true, attributeFilter: ['class'] });
      }
    }

    hydrateRatings() {
      if (window.jdgm && typeof window.jdgm.batchRenderBadges === 'function') {
        window.jdgm.batchRenderBadges();
      } else if (window.jdgmCacheServer && typeof window.jdgmCacheServer.reloadAll === 'function') {
        window.jdgmCacheServer.reloadAll();
      }
    }

    onClick(event) {
      const button = event.target.closest('.complete-setup__add');
      if (!button || button.classList.contains('loading')) return;
      if (button.hasAttribute('data-quick-view')) {
        this.openQuickView(button);
        return;
      }
      this.addToCart(button);
    }

    async openQuickView(button) {
      const quickView = document.querySelector('cart-quick-view');
      if (!quickView || typeof quickView.open !== 'function') {
        if (button.dataset.productUrl) window.location.href = button.dataset.productUrl;
        return;
      }
      button.classList.add('loading');
      try {
        await quickView.open(button.dataset.productUrl, button.closest('.complete-setup__card'));
      } finally {
        button.classList.remove('loading');
      }
    }

    async addToCart(button) {
      const variantId = parseInt(button.dataset.variantId, 10);
      if (!variantId) return;
      button.classList.add('loading');
      button.setAttribute('disabled', '');
      const item = { id: variantId, quantity: 1 };
      try {
        if (button.dataset.fitmentNode) {
          await fetch(window.Shopify.routes.root + 'cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ attributes: { _fitment_node: button.dataset.fitmentNode } })
          }).catch(() => {});
        }
        const drawerSectionId = window.cartDrawerSectionId ? window.cartDrawerSectionId() : 'cart-drawer';
        const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items: [item],
            sections: drawerSectionId + ',cart-icon-bubble'
          })
        });
        if (!response.ok) {
          const data = await response.json();
          throw new Error(data.description || 'Error adding item to cart');
        }
        const data = await response.json();
        const cartDrawer = this.closest('cart-drawer');
        if (cartDrawer && data.sections) {
          cartDrawer.renderContents({ sections: data.sections });
        }
      } catch (error) {
        console.error('cart-complete-setup: add to cart failed', error);
      } finally {
        button.classList.remove('loading');
        button.removeAttribute('disabled');
      }
    }
  }

  customElements.define('cart-complete-setup', CartCompleteSetup);
}
